module.exports = __webpack_public_path__ + "static/media/login-icon.3de3d8e1.svg";